<template>
  <div class="agreement-container">
    <h1 class="agreement-title">INSPAY User Agreement</h1>
    <h2>I. General Provisions of the User Agreement</h2>
    <ol>
      <li>
        This agreement is made between Pangluming (hereinafter referred to as
        the "Operator") and the registered users of INSPAY (including services
        provided through mobile apps and other products, hereinafter referred to
        as "Products and Services") (hereinafter referred to as the "Users").
      </li>
      <li>
        Before registering, Users must carefully read the terms of this
        agreement and complete all the registration procedures as prompted on
        the page. Only users aged 18 or above are eligible to register. Users
        from the Chinese mainland are not allowed to use this software as this
        software is distributed globally except for the Chinese mainland.
      </li>
      <li>
        By clicking the "Agree" button during the registration process, the User
        is deemed to have fully understood and accepted all the terms of this
        agreement and has thus entered into this agreement with the Operator.
      </li>
      <li>
        The Operator reserves the right to modify or supplement relevant rules
        under this agreement from time to time and will publish such changes on
        the website. If Users continue to use the services, they will be deemed
        to have accepted the revised terms of this agreement.
      </li>
    </ol>
    <h2>II. Instructions for Using the Service</h2>
    <ol>
      <li>
        During registration, Users must fill in accurate personal information
        such as username, password, mobile phone number, and email address,
        ensuring completeness, accuracy, and truthfulness. They also need to
        provide proof of age to confirm they are 18 or older.
      </li>
      <li>
        Once registered, Users become legal registered users of the Operator,
        receiving a user account and corresponding password. Users may change
        their password at any time and are fully responsible for the security of
        their account, as well as for all actions and events that occur under
        their username.
      </li>
      <li>
        Users agree to receive commercial information sent by the Operator or
        other means.
      </li>
      <li>
        The Operator is not responsible for the deletion or storage failure of
        information posted by Users.
      </li>
      <li>
        The Operator has the right to determine whether a User's behavior
        complies with the service terms of this site. If a User violates the
        service terms, the Operator has the right to interrupt or terminate the
        User's access to network services.
      </li>
      <li>
        The Operator provides account deletion services. If Users wish to delete
        their account, they can contact the Operator using the contact
        information provided in this agreement.
      </li>
      <li>
        Users may not transfer, lend, sell, or share their account for any
        illegal purposes or otherwise (user accounts are for personal use only).
      </li>
    </ol>
    <h2>III. Changes and Amendments to the Agreement</h2>
    <ol>
      <li>
        The Operator reserves the right to modify the service terms as
        necessary. The modified agreement can be viewed on the Operator’s
        website.
      </li>
      <li>
        If a User disagrees with the changes made by the Operator, they may
        discontinue using the website's services.
      </li>
      <li>
        If a User continues to use the website's services, it is considered
        acceptance of the changes to the service terms.
      </li>
      <li>
        The Operator may interrupt or terminate one or more network services at
        any time based on actual circumstances without assuming responsibility
        to any User or third party. If Users object to the interruption or
        termination of one or more services, they may exercise the following
        rights: (1) Discontinue the use of the Operator's network services. (2)
        Notify the Operator to cease providing services to the User. After the
        User service ends, the User's right to use the network services will
        immediately terminate, and from that point, the User no longer has the
        right to process any unfinished information or services. The Operator
        has no obligation to transmit any unfinished information or services to
        the User or any third party.
      </li>
    </ol>
    <h2>IV. Protection of User Privacy</h2>
    <ol>
      <li>
        The Operator will strictly adhere to its obligation to maintain the
        confidentiality of User personal information, promising not to disclose,
        edit, or reveal Users' personal information, except in the following
        special circumstances:
      </li>
      <li>With prior permission from the registered User;</li>
      <li>
        To comply with national laws and regulations or cooperate with relevant
        government departments;
      </li>
      <li>To comply with the Operator’s legitimate service procedures;</li>
      <li>
        When necessary to protect public interest or the legitimate rights and
        interests of the Operator.
      </li>
    </ol>
    <h2>V. Rights and Obligations of Registered Users</h2>
    <ol>
      <li>
        When using the Operator's products and services, registered Users must
        comply with the laws and regulations applicable in their respective
        regions. However, this software is not available for users in the
        Chinese mainland. Users agree not to engage in any illegal or improper
        activities, otherwise, Users will bear all legal responsibilities
        arising from such activities.
      </li>
      <li>
        During the use of the account, Users must not upload, display, post,
        spread, or otherwise transmit any information containing the following:
      </li>
      <li>
        Content that endangers national security, leaks state secrets, subverts
        state power, or undermines national unity;
      </li>
      <li>Content that damages national honor and interests;</li>
      <li>
        Content that incites ethnic hatred or discrimination, or undermines
        national unity;
      </li>
      <li>
        Content that undermines the state's religious policies or promotes cults
        or superstitions;
      </li>
      <li>
        Content that spreads rumors, disrupts social order, or undermines social
        stability;
      </li>
      <li>
        Content that disseminates obscene, pornographic, gambling - related,
        violent, murderous, terroristic, or criminally instigative material;
      </li>
      <li>
        Content that insults or slurs others, or infringes on the legitimate
        rights of others;
      </li>
      <li>
        Content that is false, harmful, threatening, violates others' privacy,
        harassing, offensive, defamatory, vulgar, obscene, or otherwise morally
        objectionable.
      </li>
      <li>
        Users must not use the network service system for any illegal purposes.
      </li>
      <li>
        Users must not deliberately create or spread computer viruses or engage
        in any other activities that harm network security using the Operator’s
        products and services.
      </li>
      <li>
        If a User violates the above provisions, the Operator has the right to
        independently judge and immediately cancel the User's service account.
        Users are fully responsible for their online actions, and the Operator's
        system records may be used as evidence of a User's violation of the law
        and submitted to relevant authorities.
      </li>
      <li>
        Users agree to protect and maintain the interests of all members of the
        Operator and other Users. If a User’s violation of this agreement or any
        relevant laws causes losses to the Operator or any third party, the User
        will bear the resulting legal responsibilities.
      </li>
    </ol>

    <h2>VI. Ownership of Operator's Network Service Content</h2>
    <ol>
      <li>
        The Operator defines the network service content, including but not
        limited to: U - cards, virtual currency, ATMs, cash services,
        blockchain, USDT, etc. Such content is protected by the Copyright Law,
        Trademark Law, Patent Law, Computer Software Protection Regulations, and
        other relevant laws and regulations.
      </li>
      <li>
        Without prior permission from the Operator or any other authorized third
        party, Users must not reproduce, copy, distribute, or otherwise infringe
        upon any content, including but not limited to source code and
        trademarks, nor engage in any actions that violate intellectual property
        rights laws, or they will bear all civil, administrative, or criminal
        liabilities.
      </li>
    </ol>
    <h2>VII. Disclaimer</h2>
    <ol>
      <li>
        Users agree to bear all risks and consequences arising from the use of
        the Operator's products and services, and the Operator is not
        responsible for any damages.
      </li>
      <li>
        The Operator does not guarantee that the services will meet the User's
        requirements, nor does it guarantee uninterrupted service. The Operator
        does not make any guarantees regarding the timeliness, security, or
        occurrence of technical errors in the service.
      </li>
      <li>
        The Operator is not responsible for any risks or losses to Users
        resulting from personal information leakage, loss, theft, or alteration
        due to non - intentional or gross negligence by the Operator, including
        but not limited to hacker attacks, computer virus infections, government
        regulations, hardware failures, or force majeure.
      </li>
    </ol>
    <h2>VIII. Other Provisions</h2>
    <ol>
      <li>
        Users agree that any disputes arising from the platform's services are
        subject to the laws of the country or region where the User is located,
        except for users in the Chinese mainland who are not eligible to use
        this service. Either party may bring a lawsuit to the relevant court
        according to the applicable jurisdiction.
      </li>
      <li>
        The titles in this agreement are for convenience only and do not affect
        the interpretation of the terms themselves. If any provision of this
        agreement is wholly or partially invalid or unenforceable for any
        reason, the remaining provisions will remain binding.
      </li>
    </ol>
    <h2>IX. Contact Us</h2>
    <p>
      If you have any questions, comments, or suggestions about this agreement
      or the services, you can contact us through the following methods:
    </p>
    <p>Email: mengxiangdao123@outlook.com</p>
  </div>
</template>

<style scoped>
.agreement-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.agreement-title {
  color: #333;
  /* font-size: 32px; */
  font-weight: 600;
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #eee;
}

/* h2 {
  color: #2c3e50;
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 20px;
} */

ol {
  padding-left: 20px;
  line-height: 1.6;
}

li {
  margin-bottom: 12px;
  color: #666;
}

p {
  color: #666;
  line-height: 1.6;
}
</style>
<script>
export default {
  name: "AccountDeletionStatement",
  created() {
    // 在组件创建时立即滚动到顶部
    window.scrollTo(0, 0);
  },
  mounted() {
    // 组件挂载后再次确保滚动到顶部
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
};
</script>
